const KEY = 'accessToken';
export function getAuth(config) {
    const { scopes: requiredScopes } = config.pie;
    const auth = window.localStorage.getItem(KEY);
    if (!auth)
        return false;
    try {
        const { accessToken, refreshToken, expiry, scopes } = JSON.parse(auth);
        // Check it has not expired
        if (Date.now() > expiry) {
            // Instead of clearing auth, we can try to refresh using the refresh token
            return refreshToken ? { accessToken, refreshToken } : false;
        }
        // Check the token is authenticated for all the scopes we need
        const authenticatedScopes = new Set(scopes);
        const hasAllScopes = requiredScopes.every((scope) => authenticatedScopes.has(scope));
        if (!hasAllScopes) {
            clearAuth();
            return false;
        }
        return { accessToken, refreshToken };
    }
    catch (e) {
        // This means it's corrupted and we don't know how to read it,
        // so delete the entry and start over
        clearAuth();
        return false;
    }
}
export function setAuth({ accessToken, expiry, refreshToken, scopes, }) {
    window.localStorage.setItem(KEY, JSON.stringify({
        accessToken,
        refreshToken,
        expiry,
        scopes,
    }));
}
export function clearAuth() {
    window.localStorage.removeItem(KEY);
}
